
import { memo } from "react";
import { WordCard } from "@/components/WordCard";
import type { Word } from "@/lib/game-utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface WordCardsProps {
  words: Word[];
  selectedWords: Array<{ word: Word; order: number }>;
  onWordClick: (word: Word) => void;
  onSubmit: () => void;
  selectedRule: boolean;
  disabled?: boolean;
}

function WordCardsComponent({ 
  words, 
  selectedWords, 
  onWordClick, 
  onSubmit, 
  selectedRule, 
  disabled 
}: WordCardsProps) {
  const isMobile = useIsMobile();
  
  // Split words into two rows: first 3 and last 2
  const firstRow = words.slice(0, 3);
  const secondRow = words.slice(3);

  return (
    <div className="w-full mx-auto px-1">
      {/* First row with 3 cards */}
      <div className="flex justify-center gap-1 mb-2">
        {firstRow.map((word) => {
          const selectedWord = selectedWords.find(w => w.word === word);
          return (
            <div key={word} className="relative">
              <WordCard
                word={word}
                onClick={() => {
                  console.log("Word card clicked:", word);
                  onWordClick(word);
                }}
                selected={Boolean(selectedWord)}
                disabled={disabled}
              />
              {selectedWord && (
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-white border-2 border-black rounded-full flex items-center justify-center text-black font-bold text-sm z-10">
                  {selectedWord.order}
                </div>
              )}
            </div>
          );
        })}
      </div>
      
      {/* Second row with 2 cards */}
      <div className="flex justify-center gap-1">
        {secondRow.map((word) => {
          const selectedWord = selectedWords.find(w => w.word === word);
          return (
            <div key={word} className="relative">
              <WordCard
                word={word}
                onClick={() => {
                  console.log("Word card clicked:", word);
                  onWordClick(word);
                }}
                selected={Boolean(selectedWord)}
                disabled={disabled}
              />
              {selectedWord && (
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-white border-2 border-black rounded-full flex items-center justify-center text-black font-bold text-sm z-10">
                  {selectedWord.order}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export const WordCards = memo(WordCardsComponent);
